module.exports = __webpack_public_path__ + "static/media/Trama-LatamChequea-white.8f7ed27d.jpg";